import { tv } from 'tailwind-variants';

export const defaultVariants = tv({
  slots: {
    base: ['flex', 'flex-col', 'gap-6', 'items-start', 'w-full', 'max-w-component', 'mx-auto'],
    filterRow: ['flex', 'flex-col', 'gap-2', 'w-full'],
    select: [
      'w-full px-3 py-1.5',
      'bg-white text-base text-[#495057] text-ellipsis font-medium',
      'border rounded-sm',
    ],
    content: ['w-full', 'text-left'],
    tableWrapper: ['w-full', 'overflow-x-auto'],
    table: ['w-full', 'border-collapse', 'text-textPrimary font-medium'],
    row: ['odd:bg-[rgba(0,0,0,0.05)]', 'even:bg-white'],
    cell: ['p-3', 'align-middle', 'border border-[#dee2e6]'],
    cellFile: ['text-center'],
    cellEmpty: ['text-center'],
    fileLink: [
      'inline-flex items-center gap-1',
      'max-w-75 align-middle',
      'text-primary',
      'hover:text-secondary',
    ],
  },
});
